/*
 * @Author Kenny <kenny@growwithom.com>
 * @description Application entry point
 */

// Do not remove
require('intersection-observer')
import lozad from 'lozad'
import bootstrap from 'bootstrap'

//const targets = document.querySelectorAll('img')
//const el = document.querySelector('img')
const observer = lozad() 
observer.observe()


//If using vue comment or remove jQuery
// eslint-disable-next-line no-undef
jQuery(document).ready(function($) {
  
  // Calculator code
  (function($) {
    $.fn.serializeObject = function() {
      var o = {}
      var a = this.serializeArray()
      $.each(a, function() {
        if (o[this.name] !== undefined) {
          if (!o[this.name].push) {
            o[this.name] = [o[this.name]]
          }
          o[this.name].push(this.value || '')
        } else {
          o[this.name] = this.value || ''
        }
      })
      return o
    }

    var formatNumber = function(int) {
      var pieces = parseFloat(int)
        .toFixed(0)
        .split('')
      var piecesCounter = pieces.length

      while ((piecesCounter -= 3) > 0) {
        pieces.splice(piecesCounter, 0, ',')
      }

      return pieces.join('')
    }

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
      // All pages
      common: {
        init: function() {
          var formValidated = false

          if ($('.calculator').length > 0) {
            $('.calculator--form').on('submit', function(e) {
              e.preventDefault()

              var $form = $(this)
              var formData = $form.serializeObject()

              var totalSalary = formData.salary * 1.3
              // Weeks * Minutes of Increase Per Week / Mintues in hours * number of employees
              var annualHealthSavings =
                Math.round(96.36 * formData.stress * formData.employees * 100) / 100
              // Weeks * Minutes of Increase Per Week / Mintues in hours * number of employees
              var annualProductivityBoost =
                Math.round(((48 * 47) / 60) * formData.employees * 100) / 100
              // 37.6 hours * formData.employees * (formData.salary * 1.3)/48 work weeks per year /40
              var annualProductivityValue =
                Math.round(37.6 * formData.employees * ((formData.salary * 1.3) / 48 / 40) * 100) /
                100

              $('#calculator--savings-total-sum').text(
                '$' + formatNumber(annualHealthSavings) + '+'
              )
              $('#calculator--boost-total-sum').text(
                '$' + formatNumber(annualProductivityBoost) + '+'
              )
              $('#calculator--value-total-sum').text(
                '$' + formatNumber(annualProductivityValue) + '+'
              )
            })
          }

          $('#blogCategoryfilter').on('change', function(e) {
            e.preventDefault()
            var filteredCategory = $('#blogCategoryfilter option:selected').val()
            console.log(filteredCategory)
            if (filteredCategory != 'all-posts') {
              window.location.replace(`/media/?category=${filteredCategory}`)
            } else {
              window.location.replace('/media')
            }
          })
        },
        finalize: function() {
          // JavaScript to be fired on all pages, after page specific JS is fired
        },
      },
      // Home page
      home: {
        init: function() {
          // JavaScript to be fired on the home page
        },
        finalize: function() {
          // JavaScript to be fired on the home page, after the init JS
        },
      },
      // About us page, note the change from about-us to about_us.
      about_us: {
        init: function() {
          // JavaScript to be fired on the about us page
        },
      },
    }

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
      fire: function(func, funcname, args) {
        var fire
        var namespace = Sage
        funcname = funcname === undefined ? 'init' : funcname
        fire = func !== ''
        fire = fire && namespace[func]
        fire = fire && typeof namespace[func][funcname] === 'function'

        if (fire) {
          namespace[func][funcname](args)
        }
      },
      loadEvents: function() {
        // Fire common init JS
        UTIL.fire('common')

        // Fire page-specific init JS, and then finalize JS
        $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
          UTIL.fire(classnm)
          UTIL.fire(classnm, 'finalize')
        })

        // Fire common finalize JS
        UTIL.fire('common', 'finalize')
      },
    }

    // Load Events
    $(document).ready(UTIL.loadEvents)
  })(jQuery) // Fully reference jQuery after this point.
$('.custom-logo').attr('data-no-retina')
  //Card Buttons
  var width = $(window).width()
  $('.leader-btn').click(function(e) {
    $('.leader-btn').addClass('active')
    $('.board-btn').removeClass('active')
    $('.board').css('display', 'none')
    if (width > 768) {
      $('.team').css('display', 'flex')  
    } else {
      $('.team').css('display', 'block')
       $('.team').slick('setPosition')
    }
  })

  $('.board-btn').click(function(e) {
    $('.leader-btn').removeClass('active')
    $('.board-btn').addClass('active')
    if (width > 768){
      $('.board').css('display', 'flex')
      $('.team').css('display', 'none')
    } else {
      $('.board').css('display', 'block')
       $('.team').css('display', 'none')
      $('.board').slick('setPosition')
    }

  })

  $('.navbar-toggler').click(function(e) {
    if ($('#main-nav-two').hasClass('show')) {
      $('#nav-tag').removeClass('nav-open')
      $('#main-header').removeClass('relative')
    } else {
      $('#nav-tag').addClass('nav-open')
      $('#main-header').addClass('relative')
    }
  })

  // HOMEPAGE VIDEO MODAL (Remove width & height)
  $('#homePageVideoModal, #resultsPageVideoModal').on('shown.bs.modal', function(e) {
    $('#homePageVideoModal iframe, #resultsPageVideoModal iframe').width('100%')
    $('#homePageVideoModal iframe, #resultsPageVideoModal iframe').height('100%')
  })

  //Stop playing video on close
  $('#homePageVideoModal, #resultsPageVideoModal').on('hide.bs.modal', function(e) {
    $('#homePageVideoModal iframe, #resultsPageVideoModal iframe').attr(
      'src',
      $('#homePageVideoModal iframe, #resultsPageVideoModal iframe').attr('src')
    )
  })
  // Salesforce Form modal
  $('.form-button, #mobileFormClose, .menu-item-415, .dropdown-item-476').click(function() {
    if ($('.popup').is(':visible')) {
      $('.popup').slideToggle()
    } else {
      $('.popup').slideToggle()
    }
  })

    $('.form-button-study, #mobileFormCloseStudy').click(function() {
      if ($('.popup-study').is(':visible')) {
        $('.popup-study').slideToggle()
      } else {
        $('.popup-study').slideToggle()
      }
    })


  $('.testimonial-slider,.tribe-slider').slick({
    adaptiveHeight: false,
    mobileFirst: true,
    dots: true,
    infinite: true,
    speed: 2000,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false,
  })

  $('.testimonial-double-slider').slick({
    adaptiveHeight: false,
    mobileFirst: true,
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  })

  $('.logo-slider').slick({
    adaptiveHeight: false,
    mobileFirst: true,
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 2000,
    slidesToShow: 2,
    slidesToScroll: 2,
    prevArrow: false,
    nextArrow: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  })
  $('.tribe-slider-two').slick({
    adaptiveHeight: false,
    mobileFirst: true,
    dots: true,
    infinite: true,
    speed: 2000,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })


  let $slick_slider = $('.slider')
  let settings = {
    // some settings
    adaptiveHeight: false,
    mobileFirst: true,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false,
  }
  // let timeout = false // holder for timeout id
  // const delay = 250 // delay after event is "complete" to run callback
  // let calls = 0
  // let w = document.querySelector("#width")
  // let h = document.querySelector("#height")
  // let c = document.querySelector("#calls")

    // window.resize callback function
  // function getDimensions() {
  //   w.innerHTML = window.innerWidth;
  //   h.innerHTML = window.innerHeight;
  //   calls += 1;
  //   c.innerHTML = calls;
  // }
  // reslick only if it's not slick()
  $(window).on('load resize', function() {
    // clear the timeout
    // clearTimeout(timeout);
    // start timing for event "completion"
    // timeout = setTimeout(getDimensions, delay);
    if ($(window).width() < 768) {
      if (!$slick_slider.hasClass('slick-initialized')) {
        return $slick_slider.slick(settings)
      }
      return
    }
      if ($slick_slider.hasClass('slick-initialized')) {
        $slick_slider.slick('unslick')
      }
  })
  // getDimensions()
})
